import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { Messaging, getToken } from '@angular/fire/messaging';
import { Auth, onIdTokenChanged } from '@angular/fire/auth';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { Firestore, doc, setDoc, addDoc, collection } from '@angular/fire/firestore';

@Injectable({
	providedIn: 'root'
})
export class MessagingService {
	constructor(private messaging: Messaging, private auth: Auth, private firestore: Firestore) { }
	requestPermission() {
		return Notification.requestPermission();
	}

	login() {
		return signInWithEmailAndPassword(this.auth, environment.fire_u, environment.fire_p);
	}

	addEntryToFirebase(msgObj: any, collectionName: string) {
		const usersRef = collection(this.firestore, collectionName);
		return addDoc(usersRef, msgObj);
	}
}
